<script setup lang="ts"></script>

<template>
	<footer class="gaf-footer">
		<div class="gaf-footer__bg"></div>
		<div class="gaf-footer__content">
			<div class="gaf-footer__content__grid">
				<div class="gaf-footer__content__grid__item">
					<h3 class="gaf-footer__content__grid__info__title">Juvenice</h3>
					<p class="gaf-footer__content__grid__item__subtitle">Giovani Amici della Fenice</p>
				</div>
				<div class="gaf-footer__content__grid__item">
					<h4 class="gaf-footer__content__grid__item__title">Link Utili</h4>
					<ul class="gaf-footer__content__grid__item__links">
						<li class="gaf-footer__content__grid__item__links__item">
							<router-link to="/info" class="gaf-footer__content__grid__item__links__item__link"
								>Chi Siamo</router-link
							>
						</li>
						<li class="gaf-footer__content__grid__item__links__item">
							<router-link to="/associate" class="gaf-footer__content__grid__item__links__item__link"
								>Diventa Socio</router-link
							>
						</li>
						<li class="gaf-footer__content__grid__item__links__item">
							<router-link to="/about-us" class="gaf-footer__content__grid__item__links__item__link"
								>Dicono di Noi</router-link
							>
						</li>
						<li class="gaf-footer__content__grid__item__links__item">
							<router-link to="/contacts" class="gaf-footer__content__grid__item__links__item__link"
								>Contatti</router-link
							>
						</li>
					</ul>
				</div>
				<div class="gaf-footer__content__grid__item">
					<h4 class="gaf-footer__content__grid__item__title">Contatti</h4>
					<p class="gaf-footer__content__grid__item__subtitle">segreteria@giovaniamicifenice.it</p>
					<h4 class="gaf-footer__content__grid__item__title">Sede legale</h4>
					<p class="gaf-footer__content__grid__item__subtitle">
						Calle delle Schiavine, San Marco 4387, Venezia
					</p>
				</div>
				<div class="gaf-footer__content__grid__item">
					<h4 class="gaf-footer__content__grid__item__title">Seguici</h4>
					<div class="gaf-footer__content__grid__item__socials">
						<a
							href="https://instagram.com/giovani_fenice"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="Instagram"
							class="gaf-footer__content__grid__item__socials__link"
							title="Instagram"
						>
							<i class="pi pi-instagram" />
						</a>
						<a
							href="https://facebook.com/giovaniamicifenice"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="Facebook"
							title="Facebook"
							class="gaf-footer__content__grid__item__socials__link"
						>
							<i class="pi pi-facebook" />
						</a>
					</div>
				</div>
			</div>
			<div class="gaf-footer__copyright">
				<p class="gaf-footer__copyright__label">
					© 2025 Giovani Amici della Fenice. Tutti i diritti riservati. CF. 94083700271
				</p>
			</div>
		</div>
	</footer>
</template>

<style scoped lang="scss">
@keyframes fade {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.gaf-footer {
	position: relative;
	background: $primary-light;
	color: $primary-foreground-light;
	padding: 4rem 0;
	overflow: hidden;
	animation: fade 0.6s ease-out;

	&_bg {
		position: absolute;
		inset: 0;
		background: linear-gradient(to bottom right, $primary-light, $primary-light, rgba($primary-light, 0.9));
	}

	&__content {
		position: relative;
		z-index: 10;
		max-width: 80rem;
		margin: 0 auto;
		padding: 0 1.5rem;

		&__grid {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
			gap: 3rem;

			@media (min-width: 768px) {
				grid-template-columns: repeat(4, 1fr);
			}

			&__item {
				&__title {
					@include font-body-small;
					font-weight: 600;
					text-transform: uppercase;
					letter-spacing: 0.1em;
					margin-bottom: 1rem;
				}

				&__subtitle {
					@include font-body-small;
					opacity: 0.9;
					line-height: 1.75;
				}

				&__links {
					list-style: none;
					padding: 0;
					margin: 0;

					&__item {
						margin-bottom: 0.75rem;

						&__link {
							@include font-body-small;
							color: inherit;
							text-decoration: none;
							transition: all 0.3s ease;
							display: inline-block;

							&:hover {
								color: $accent-light;
								transform: translateX(4px);
							}
						}
					}
				}

				&__socials {
					display: flex;
					align-items: center;
					gap: 1rem;

					&__link {
						color: inherit;
						transition: all 0.3s ease;

						&:hover {
							color: $accent-light;
							transform: scale(1.1);
						}
					}
				}
			}

			&__info {
				&__title {
					@include font-heading;
					font-size: 1.5rem;
					font-weight: 600;
					margin-bottom: 1rem;
				}

				&__subtitle {
					@include font-body-small;
					opacity: 0.9;
					line-height: 1.75;
				}
			}
		}
	}

	&__copyright {
		margin-top: 4rem;
		padding-top: 2rem;
		border-top: 1px solid rgba($primary-foreground-light, 0.2);
		text-align: center;

		p {
			@include font-body-small;
			opacity: 0.75;
		}
	}
}
</style>
